import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

export default class extends Controller {
  static values = {
    type: String // 'banner' or 'products'
  }

  connect() {
    const element = this.element

    let options = {
      modules: [Navigation, Pagination],
      loop: true,
    }

    if (this.typeValue === 'banner') {
      options = {
        ...options,
        modules: [Autoplay, Navigation, Pagination],
        pagination: {
          el: element.querySelector(".swiper-pagination"),
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        }
      }
    } else if (this.typeValue === 'products') {
      const navigationRoot = element.querySelector(".swiper-button-next") ? element : element.parentElement

      options = {
        ...options,
        navigation: {
          nextEl: navigationRoot.querySelector(".swiper-button-next"),
          prevEl: navigationRoot.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 20 },
          480: { slidesPerView: 2, spaceBetween: 32 },
          768: { slidesPerView: 3, spaceBetween: 32 },
          1024: { slidesPerView: 4, spaceBetween: 32 }
        }
      }
    }

    this.swiper = new Swiper(element, options)
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
